import { palette } from "../../../../../theme/palette";
const theme = palette('light');
export const headerStyle = {
    background: theme.black.main,
    borderTopLeftRadius: '25px',
    borderTopRightRadius: '25px',
    padding: '15px 25px',
};
export const card = {
    padding: '32px',
    background: 'white',
    borderRadius: '25px',
};
